import { useQuery } from "@tanstack/react-query";
import type {
  CategoriaServico,
  Familia,
  Municipio,
  Orcamento,
  OrcamentoDetalhe,
  Painel,
  Sindicato,
  Usuario,
} from "../../../shared/tipos";
import { api } from "./cliente";

export const chaves = {
  painel: ["painel"] as const,
  familias: ["familias"] as const,
  sindicatos: ["sindicatos"] as const,
  municipios: ["municipios"] as const,
  orcamentos: ["orcamentos"] as const,
  orcamento: (id: number) => ["orcamento", id] as const,
  modelos: (id: number) => ["orcamento", id, "modelos"] as const,
  usuarios: ["usuarios"] as const,
  categorias: ["compor", "categorias"] as const,
};

const LONGO = 10 * 60 * 1000; // dados de referência mudam raramente

export const usePainel = () => useQuery({ queryKey: chaves.painel, queryFn: () => api<Painel>("/api/painel") });
export const useFamilias = () =>
  useQuery({ queryKey: chaves.familias, queryFn: () => api<Familia[]>("/api/familias"), staleTime: LONGO });
export const useSindicatos = () =>
  useQuery({ queryKey: chaves.sindicatos, queryFn: () => api<Sindicato[]>("/api/sindicatos"), staleTime: LONGO });
export const useMunicipios = () =>
  useQuery({ queryKey: chaves.municipios, queryFn: () => api<Municipio[]>("/api/municipios"), staleTime: LONGO });
export const useOrcamentos = () =>
  useQuery({ queryKey: chaves.orcamentos, queryFn: () => api<Orcamento[]>("/api/orcamentos") });
export const useOrcamento = (id: number) =>
  useQuery({ queryKey: chaves.orcamento(id), queryFn: () => api<OrcamentoDetalhe>(`/api/orcamentos/${id}`) });
export const useUsuarios = () =>
  useQuery({ queryKey: chaves.usuarios, queryFn: () => api<Usuario[]>("/api/usuarios") });
export const useCategorias = () =>
  useQuery({
    queryKey: chaves.categorias,
    queryFn: () => api<CategoriaServico[]>("/api/compor/categorias"),
    staleTime: Infinity,
  });
